__turbopack_context__.v({
  "bar1": "index-module__e9nZTG__bar1",
  "bar2": "index-module__e9nZTG__bar2",
  "bar3": "index-module__e9nZTG__bar3",
  "bar4": "index-module__e9nZTG__bar4",
  "bar5": "index-module__e9nZTG__bar5",
  "playing": "index-module__e9nZTG__playing",
  "waveAnimation1": "index-module__e9nZTG__waveAnimation1",
  "waveAnimation2": "index-module__e9nZTG__waveAnimation2",
  "waveAnimation3": "index-module__e9nZTG__waveAnimation3",
  "waveAnimation4": "index-module__e9nZTG__waveAnimation4",
  "waveAnimation5": "index-module__e9nZTG__waveAnimation5",
});
